(function() {
    angular
        .module('emarket.main.post')
        .controller('CustomFilterController', ['$timeout', '$log', '$scope', '$rootScope', '$location', '$mdMedia', function($timeout,
            $log,
            $scope,
            $rootScope,
            $location,
            $mdMedia) {
            var filters = $scope.$parent.model.metadata.filter.custom;
            var vm = this;
            var spanSizeCount = 4;
            var terms = $location.search();
            vm.hideTabs = true;
            vm.filter = {};
            //list of selected filter as array for use on mdchips
            vm.filterList = [];

            var searchName = function(slug) {
                var filter = filters.filter(function(filter) {
                    return filter.slug === slug;
                })[0];
                return filter ? filter.name : null;
            };

            var getFilter = function(slug) {
                var index;
                filters.some(function(filter, i) {
                    if (filter.slug === slug) {
                        index = i;
                        return true;
                    }
                });
                return filters[index];
            };
            vm.applyFilter = function() {
                vm.filterList = Object.keys(vm.filter).map(function(key) {
                    var filter = getFilter(key);
                    return {
                        name: filter.name,
                        slug: key,
                        value: vm.filter[key]
                    };
                });
                $timeout(function() {
                    vm.filterList = Object.keys(vm.filter).map(function(key) {
                        var filter = getFilter(key);

                        $location.search('f_' + key, vm.filter[key]);

                        return {
                            name: filter.name,
                            slug: key,
                            value: key === 'ubicacion' ? vm.filter[key].split(',')[2] : vm.filter[key]
                        };
                    });
                }, 400);
                vm.hideTabs = true;
            };
            var clearFilter = function(key) {
                $location.search('f_' + key, null);
                delete vm.filter[key];
            };
            vm.removeFilter = clearFilter;
            vm.clearFilters = function() {
                vm.hideTabs = true;
                $timeout(function() {
                    Object.keys(vm.filter).forEach(function(key) {
                        clearFilter(key);
                    });
                    vm.filterList = [];
                }, 400);
            };

            var groups = {};
            filters.forEach(function(filter) {
                if (!groups[filter.group]) {
                    groups[filter.group] = [];
                }
                groups[filter.group].push(filter);
            });
            vm.filters = filters; //filters.length > 0 ? groups : null;
            vm.getSpanSize = function(filter) {
                var list = filter.values.length;
                if (filter.extraText) {
                    list += 1;
                }
                var size = spanSizeCount - list;
                size = size > 0 ? size : 0;
                return new Array(size);
            };
            $scope.$watch(function() {
                return vm.filter;
            },
            function() {
                if (($mdMedia('xs') || $mdMedia('sm')) && vm.filter) {
                    vm.applyFilter();
                }
            },
            true);
            var loadInitialFilters = function() {
                vm.filterList = [];
                var queryString = $location.search();
                //load initial filters
                Object.keys(queryString).forEach(function(key) {
                    if (/^f_/.test(key)) {
                        var k = key.replace(/^f_/, '');
                        vm.filter[k] = queryString[key];
                        var filter = {
                            name: searchName(k),
                            slug: k,
                            value: queryString[key]
                        };

                        if (k === 'ubicacion') {
                            filter.value = filter.value.split(',')[2];
                        }
                        var exists = vm.filterList.some(function(_filter) {
                            return _filter.slug === filter.slug;
                        });
                        if (!exists) {
                            vm.filterList.push(filter);
                        }
                    }
                });
            };
            $rootScope.$on('$locationChangeSuccess', function() {
                loadInitialFilters();
            });
            loadInitialFilters();
        }]);
}());
